// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";

export {
    imgSuccess,
    imgWheel,
    imgExclamation,
    imgCross,
    imgVfLogo,
    imgCancelled,
    imgLogout,
    imgBmpLogo
} from "./foreign.js";
//# sourceMappingURL=index.js.map
